export default require('./ProgressBar').default
